module.exports = __webpack_public_path__ + "static/media/maf-15.5f0cb37f.png";